module.exports = __webpack_public_path__ + "769ad5ca05756d555b8ee82d722d239f.png";